import { CombinedError } from '@urql/core';
import { showErrorMessage } from 'components/Helpers/Toasts';
import { getUserFriendlyErrors } from 'connectors/lib/friendlyErrorMessageParser';
import { logException } from 'helpers/errors/logException';
import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';
import { usePersistStore } from 'store/usePersistStore';

export const useQueryError = (error: CombinedError | undefined, suppressError = false): void => {
    const { t } = useTranslation();
    const authLoading = usePersistStore((s) => s.authLoading);

    useEffect(() => {
        if (error === undefined || suppressError) {
            return;
        }

        if (error.message === 'Token is not valid') {
            if (authLoading !== 'logout-loading') {
                showErrorMessage(t('You were automatically logged out after inactivity.'));
            }

            return;
        }

        const parsedErrors = getUserFriendlyErrors(error, t);

        logException(error);

        if (parsedErrors.applicationError === undefined) {
            return;
        }

        if (authLoading !== 'logout-loading') {
            showErrorMessage(parsedErrors.applicationError.message);
        }
    }, [error, suppressError, t, authLoading]);
};
